module.exports = false;


//////////////////
// WEBPACK FOOTER
// /Users/danielcodrea/personal/Projects/HOW-TO_Project/how-to/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0